export interface CompanyBranding {
  logoUrl?: string | null;
  logoPosition?: 'left' | 'center' | 'right';
  logoOnAllPages?: boolean;
  companyDisplayName?: string | null;
  headerText?: string | null;
  footerText?: string | null;
}

export interface ExportOptions {
  filename?: string;
  includeMetadata?: boolean;
  pageOrientation?: 'portrait' | 'landscape';
  stripCitations?: boolean;
  includeTimestamp?: boolean;
  includeCoverPage?: boolean;
  formatType?: 'pdf' | 'html' | 'docx';
  includeTableOfContents?: boolean;
  customHeader?: string;
  customFooter?: string;
  preserveStyling?: boolean; // New option for DOM-based PDF export
  companyBranding?: CompanyBranding; // Company logo and branding
}

export interface ExportProgress {
  stage: 'preparing' | 'rendering' | 'generating' | 'saving' | 'complete' | 'error';
  progress: number; // 0-100
  message: string;
  error?: string;
}

export interface ExportMetadata {
  generatedAt: string;
  comparisonType: string;
  documentsAnalyzed: Array<{
    id: string;
    name: string;
    type?: string;
    policyType?: string;
  }>;
  confidence: string;
  processingTime?: number;
  userInfo?: {
    name: string;
    company: string;
    email: string;
  };
}

export interface ExportResult {
  success: boolean;
  filename?: string;
  error?: string;
  size?: number;
  timestamp: string;
}

export interface ExportTemplate {
  name: string;
  description: string;
  options: ExportOptions;
  preview: string;
}

export const DEFAULT_EXPORT_OPTIONS: ExportOptions = {
  filename: undefined, // Will be auto-generated
  includeMetadata: true,
  pageOrientation: 'landscape',
  stripCitations: true,
  includeTimestamp: true,
  includeCoverPage: false,
  formatType: 'pdf',
  includeTableOfContents: false,
  customHeader: undefined,
  customFooter: undefined,
  preserveStyling: true // Enable DOM-based export by default for better styling
};

export const EXPORT_TEMPLATES: ExportTemplate[] = [
  {
    name: 'Standard Report',
    description: 'Clean, professional report with citations removed',
    options: {
      ...DEFAULT_EXPORT_OPTIONS,
      stripCitations: true,
      includeMetadata: true
    },
    preview: 'Clean format suitable for client presentations'
  },
  {
    name: 'Internal Analysis',
    description: 'Detailed report with all citations included',
    options: {
      ...DEFAULT_EXPORT_OPTIONS,
      stripCitations: false,
      includeMetadata: true,
      includeTimestamp: true
    },
    preview: 'Full detailed report with source citations'
  },
  {
    name: 'Executive Summary',
    description: 'Condensed report focusing on key findings',
    options: {
      ...DEFAULT_EXPORT_OPTIONS,
      stripCitations: true,
      includeMetadata: false
    },
    preview: 'Concise format for executive review'
  }
];